import { isDefinedString } from "et3-type-guards";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";

const ClientPersonalInfo = withLiteObserverAndTheme<{
  information: string;
  title: string;
}>((props) => {
  const { theme, title, information } = props;
  const { colors } = theme;
  const isDefinedTitle = isDefinedString(title);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={100}
      height={80}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {isDefinedTitle ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="column"
          justifyContent="flex-end"
          alignItems="center"
          withShadow={false}
          width={125}
          height={30}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={15}
            text={title}
            isSpan={true}
            color={colors.all.black}
            style={{ textAlign: "center" }}
          />
        </ET3Div>
      ) : null}
      <ET3Div
        isScrollable={true}
        isExtendable={false}
        fDirection="column"
        justifyContent="center"
        alignItems="center"
        withShadow={false}
        width={100}
        height={50}
        color={colors.all.transparent}
        style={{ overflowX: "hidden" }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={14}
          text={information}
          isSpan={true}
          color={colors.all.black}
          style={{ textAlign: "center" }}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default ClientPersonalInfo;
